import React, {useMemo, useState} from 'react'
import styles from './UIGameHelpInformationPopup.module.scss'
import 'swiper/css'
import 'swiper/css/pagination'
import {Swiper, SwiperSlide} from 'swiper/react'
import type {Swiper as SwiperType} from 'swiper'
import {Pagination} from 'swiper/modules'
import {Popup} from '../../../common/Popup/Popup'
import {UIGameHelpVPInformation} from '../UIGameHelpInformationButton/UIGameHelpVPInformation'
import {UIGameHelpCostsInformation} from '../UIGameHelpInformationButton/UIGameHelpCostsInformation'
import {PlayerColor} from '@colonist/game-states'
import {ModeSettingEnum} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'

export const UIGameHelpInformationPopup = ({
    gameMode,
    playerColor,
    victoryPointsToWin,
    isOpen,
    onClose,
}: {
    gameMode: ModeSettingEnum
    playerColor: PlayerColor
    victoryPointsToWin: number
    isOpen: boolean
    onClose: () => void
}) => {
    const [activeTab, setActiveTab] = useState<'vp' | 'costs'>('vp')

    const handleSlideChange = (swiper: SwiperType) => {
        setActiveTab(swiper.activeIndex === 0 ? 'vp' : 'costs')
    }

    const title: TranslationObject = useMemo(() => {
        if(activeTab === 'vp') {
            return {key: 'strings:game.endGame.icons.trophy'}
        }

        return {key: 'strings:game.buildCosts.title'}
    }, [activeTab])

    return (
        <Popup title={title} isOpen={isOpen} onClose={onClose}>
            <Swiper pagination={true} modules={[Pagination]} className={styles.informationPopupSwiperContainer} onSlideChange={handleSlideChange}>
                <SwiperSlide className={styles.informationPopupSwiperSlide}>
                    <UIGameHelpVPInformation gameMode={gameMode} playerColor={playerColor} victoryPointsToWin={victoryPointsToWin}/>
                </SwiperSlide>
                <SwiperSlide className={styles.informationPopupSwiperSlide}>
                    <UIGameHelpCostsInformation gameMode={gameMode} playerColor={playerColor}/>
                </SwiperSlide>
            </Swiper>
        </Popup>
    )
}
